<template>
  <div class="fund-container">
    <fund-menu v-if="menuVisible"></fund-menu>
    <fund-query v-if="!menuVisible"></fund-query>
    <fund-table></fund-table>
    <div class="hint" v-if="hintVisible">
      <div v-if="hintVisible === 'hint-select-fund'">请在左侧导航栏中选择要查看的基金主体</div>
      <div v-else-if="hintVisible === 'hint-select-table'">请选择具体报表</div>
      <div v-else-if="hintVisible === 'hint-new'">该基金主体尚无公允价值表报告，请点击上方【新建按钮】进行创建</div>
    </div>
  </div>
</template>
<script>
import fundMenu from './menu.vue';
import fundQuery from './query.vue';
import fundTable from './table.vue';
import Event from '@/utils/event';
import {  queryFairCommon } from '@/api/finance';
export default {
  data() {
    return {
      menuVisible: true,
      hintVisible: 'hint-select-fund'
    };
  },
  components: {
    fundMenu,
    fundTable,
    fundQuery
  },
  created() {},
  mounted() {
    this.initListeners();
  },
  beforeDestroy() {
    Event.$off([
      'visionRefresh',
      'refreshTable',
      'deactivateTable',
      'menu-edit-save',
      'menu-compare',
      'refreshMenu',
      'deactivateMenu',
      'switchSideMenu',
      'refreshMenuAndTable',
      'invisibleHint'
    ]);
  },
  methods: {
    async renderTable(table) {
      /**
       * 0、个性查询 menu不显示，查询菜单显示，table不显示
       * 1、基金表 refreshMenu(tableInfo->menu) refreshTable(versionId->table)
       * 2、基金主体 refreshMenu(tableInfo->menu) deactivateTable->table
       * 3、其他菜单（公允价值表、美元人民币基金等父级菜单）deactivateMenu->menu deactivateTable->table
       *
       * 基金数据结构：name,currency,children,fundId,fundName,fundType,canModify,munuType
       * 公允价值表数据结构：id,name,isReleased,fundId,fundName,isLeaf,canModify,tableCurrency,menuType
       *
       */
      debugger;
      if (table.name === '个性化查询') {
        //个性化查询
        this.hintVisible = false;
        this.menuVisible = false;
        Event.$emit('deactivateTable');
      } else if (table.isLeaf) {
        //基金表
        this.hintVisible = false;
        this.getCommonInfoList(table.id).then(tableInfo => {
          tableInfo.tableId = table.id;
          tableInfo.fundId = table.fundId;
          tableInfo.fundName = table.fundName;
          tableInfo.canModify = table.canModify;
          tableInfo.menuType = table.menuType;
          tableInfo.allowSwitch = table.allowSwitch;
          Event.$emit('refreshMenu', tableInfo);
          Event.$emit('refreshTable', {
            tableCurrency: table.tableCurrency,
            versionId: tableInfo.selectedTable.versionList[0].id
          });
        });
      } else if (table.currency) {
        //基金主体，通过判断基金主体下的表个数判断是否显示提示信息
        if (!table.children) {
          this.hintVisible = 'hint-new';
          Event.$emit('refreshMenu', {
            menuType: table.menuType,
            fundId: table.fundId,
            fundName: table.fundName,
            canModify: table.canModify,
            allowSwitch: table.allowSwitch,
            fundInfoFlag: table.fundInfoFlag
          });
          Event.$emit('deactivateTable');
        } else {
          this.getCommonInfoList(table.children[0].id).then(tableInfo => {
            tableInfo.fundId = table.fundId;
            tableInfo.fundName = table.fundName;
            tableInfo.canModify = table.canModify;
            tableInfo.menuType = table.menuType;
            tableInfo.allowSwitch = table.allowSwitch;
            tableInfo.fundInfoFlag = table.fundInfoFlag;
            Event.$emit('refreshMenu', tableInfo);
            Event.$emit('deactivateTable');
          });
          this.hintVisible = 'hint-select-table';
        }
        this.menuVisible = true;
      } else {
        //啥也没选
        this.hintVisible = 'hint-select-fund';
        this.menuVisible = true;
        Event.$emit('deactivateTable');
        Event.$emit('deactivateMenu');
      }
    },
    getCommonInfoList(fairId) {
      let tableInfo = {
        fundId: null,
        fundName: null,
        tableId: null,
        remarl: null, //判断是否为预测表
        selectedTable: null,
        tableList: [],
        canModify: false
      };
      return queryFairCommon({
        fairId: fairId
      })
        .then(res => {
          this.menuVisible = true;
          const data = res.data;
          const selectedTable = data.filter(item => item.id === fairId);
          tableInfo.selectedTable = selectedTable[0];
          tableInfo.tableList = data;
          tableInfo.remark = selectedTable[0].remark;
        })
        .then(() => tableInfo);
    },
    initListeners() {
      Event.$on('switchSideMenu', table => {
        this.renderTable(table);
      });
      Event.$on('refreshMenuAndTable', table => {
        Event.$emit('refresh-fund');
        table.isLeaf = true;
        this.renderTable(table);
      });
      Event.$on('invisibleHint', () => {
        this.hintVisible = false;
      });
    }
  }
};
</script>
<style scoped lang="less">
.fund-container {
  padding: 0 20px;
  .hint {
    margin: 0 auto;
    height: 100px;
    line-height: 100px;
    text-align: center;
    color: rgba(220, 220, 220, 1);
    font-size: 26px;
    width: 100%;
    border: 1px solid rgba(220, 220, 220, 1);
    border-radius: 20px;
  }
}</style
>>
